const getters = {
    getterProviderInfo: ({ suppliersInfo }) => suppliersInfo?.provider,
    getterConsumerInfo: ({ suppliersInfo }) => suppliersInfo?.consumer,
};
export default getters;
